import React from 'react'

const SearchTop = () => (
  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.94 21.71">
    <path
      d="M20.33 20.54l-5.81-6a8.21 8.21 0 1 0-14-5.79 8.21 8.21 0 0 0 13.41 6.28l5.82 6.05a.39.39 0 0 0 .28.12.35.35 0 0 0 .27-.11.38.38 0 0 0 .03-.55zM8.71 16.13a7.43 7.43 0 1 1 7.43-7.42 7.43 7.43 0 0 1-7.43 7.42z"
      data-name="wd-profile-page-self-home-grid-large-1 1"
    />
  </svg>
)

export default SearchTop
